export const FETCH_ALL_STEPS = 'FETCH_ALL_STEPS';
export const FETCH_ALL_STEPS_FULFILLED = 'FETCH_ALL_STEPS_FULFILLED';
export const FETCH_ALL_STEPS_REJECTED = 'FETCH_ALL_STEPS_REJECTED';
